import permissions from 'application/detail/permissions.json';
import menu_old from './menu_old.json';
import menu from './menu.json';
import menuIconsJson from './menuIcons.json';
import { MenuItemActionFeatures } from 'modules/application/misc/MenuItemActionFeature';
import { AiFeatures } from '../detail/ai/AiFeatures';
import { AttendanceFeatures } from '../detail/attendance/AttendanceFeatures';
import { PaymentsFeatures } from '../detail/payments/PaymentsFeatures';
import { aiStateName, artificialIntelligenceStateName } from '../detail/ai';
import { attendanceStateName, deskMicrofrontStateName, } from '../detail/attendance';
import { ExternalPluginFeatures } from '../detail/externalPlugin/ExternalPluginFeatures';
import { MARKETPLACE_PLUGIN_ID } from '../detail/externalPlugin/ExternalPluginController';
import { AnalyticsFeatures } from '../detail/analytics/AnalyticsFeatures';
import { analyticsStateName, dashboardStateName } from '../detail/analytics';
import { BlipStoreFeatures } from 'modules/blipStore/BlipStoreFeatures';
import { blipStoreTemplateStateName } from 'modules/blipStore';
import { Contexts } from 'modules/core/ContextProcessorService';
import { SmartSalesFeatures } from '../detail/smartSales/SmartSalesFeature';
import { SmartSalesConstants } from '../detail/portal-submodule-builder/templates/builder/smartSales/SmartSalesConstants';
import { aiAgentsAnalyticsStateName } from '../detail/aiAgents';
import { BlipPaymentsFeatures } from 'modules/blipPayments/BlipPaymentsFeatures';
import { BlipConversationsInsightsFeatures } from 'modules/blipConversationsInsights/BlipConversationsInsightsFeatures';
import { deskMfeAllStateName } from '../detail/attendance/desk';
export class MenuItemsService {
    static $inject = ['$rootScope', 'ExternalPluginService', 'SortMenuOptionsService', '$translate', 'ContextProcessorService', 'AiAgentService', 'StudioService'];
    constructor($rootScope, ExternalPluginService, SortMenuOptionsService, $translate, ContextProcessorService, AiAgentService, StudioService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.ExternalPluginService = ExternalPluginService;
        this.SortMenuOptionsService = SortMenuOptionsService;
        this.$translate = $translate;
        this.ContextProcessorService = ContextProcessorService;
        this.AiAgentService = AiAgentService;
        this.StudioService = StudioService;
        this.menu = menu_old;
    }
    async checkFeatures() {
        const isNewApplicationMenuOrderEnabled = await MenuItemActionFeatures.newApplicationMenuOrderEnabled();
        this.menu = isNewApplicationMenuOrderEnabled ? menu : menu_old;
        const isMicrofrontAiEnabled = await AiFeatures.isMicrofrontAiEnabled();
        this.aiSref = isMicrofrontAiEnabled
            ? artificialIntelligenceStateName
            : aiStateName;
        const isMicrofrontDeskEnabled = await AttendanceFeatures.isUseDeskMicroFrontendEnabled();
        this.deskSref = isMicrofrontDeskEnabled
            ? deskMicrofrontStateName
            : attendanceStateName;
        const isChannelsMfeEnabled = await AttendanceFeatures.isChannelsMfeEnabled();
        if (isChannelsMfeEnabled) {
            this.deskSref = 'auth.application.detail.attendance.desk';
        }
        const isAttendanceMenuMfeEnabled = await AttendanceFeatures.isAttendanceMenuMfeEnabled();
        if (isAttendanceMenuMfeEnabled) {
            this.deskSref = deskMfeAllStateName;
        }
        this.contentMenuItem = {};
        this.isPaymentsEnabled =
            (await PaymentsFeatures.IsPaymentsEnabled()) &&
                this.$rootScope.application.applicationUserPermissionModel.some(p => p.permissionClaim ===
                    permissions.connectionInformations.claim &&
                    p.permissionAction > 0);
        this.isSmartSalesEnabled = await SmartSalesFeatures.IsSmartSalesEnabled();
        this.IsBlipPaymentsEnabled = await BlipPaymentsFeatures.IsBlipPaymentsEnabled();
        this.isBlipConversationsInsightsEnabled = await BlipConversationsInsightsFeatures.IsBlipConversationsInsightsEnabled(this.StudioService);
        this.isPluginsEnabled = await ExternalPluginFeatures.isPluginEnabled();
        this.isMarketplacePluginEnabled = await ExternalPluginFeatures.isMarketplacePluginEnabled();
        this.isBlipStoreEnabled = await BlipStoreFeatures.isBlipStoreEnabled();
        const isDisplayingAnalyticsTabs = !await AnalyticsFeatures.isHidingAnalyticsTabs();
        this.analyticsSref = isDisplayingAnalyticsTabs
            ? analyticsStateName
            : dashboardStateName;
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await ExternalPluginFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.isStudioEnabled = await this.StudioService.shouldEnableStudioFeatures();
    }
    async getUpdatedMenus() {
        await this.checkFeatures();
        this.menuItems = [];
        const templateSetup = this.getTemplateSetupItem();
        const application = this.$rootScope.application;
        const menuKeysByPermission = Object.keys(this.menu).filter(key => {
            const claims = this.menu[key].claims;
            if (!claims.length) {
                return true;
            }
            return claims.some(claimId => application.applicationUserPermissionModel.some(userPermission => userPermission.permissionClaim == claimId &&
                userPermission.permissionAction > 0));
        });
        menuKeysByPermission.forEach(key => {
            // Verify for feature toggles
            switch (key) {
                case 'ai':
                    this.menuItems = this.menuItems.concat({
                        ...this.menu[key],
                        sref: this.aiSref,
                    });
                    break;
                case 'desk':
                    this.menuItems = this.menuItems.concat({
                        ...this.menu[key],
                        sref: this.deskSref,
                    });
                    break;
                case 'contents':
                    this.menuItems = this.menuItems.concat({
                        ...this.menu[key],
                        ...this.contentMenuItem,
                    });
                    break;
                case 'payments':
                    if (this.isPaymentsEnabled) {
                        this.menuItems = this.menuItems.concat(this.menu[key]);
                    }
                    break;
                case 'smartSales':
                    if (this.isSmartSalesEnabled) {
                        this.menuItems = this.menuItems.concat(this.menu[key]);
                    }
                    break;
                case 'blipPayments':
                    if (this.IsBlipPaymentsEnabled) {
                        this.menuItems = this.menuItems.concat(this.menu[key]);
                    }
                    break;
                case 'analysis':
                    this.menuItems = this.menuItems.concat({
                        ...this.menu[key],
                        sref: this.analyticsSref,
                    });
                    break;
                case 'blipConversationsInsights':
                    if (this.isBlipConversationsInsightsEnabled) {
                        this.menuItems = this.menuItems.concat(this.menu[key]);
                    }
                    break;
                case 'builder':
                    if (this.isStudioEnabled) {
                        this.menuItems = this.menuItems.concat({
                            ...this.menu[key],
                            title: this.$translate.instant('builder-new-version.studio'),
                        });
                    }
                    else {
                        this.menuItems = this.menuItems.concat(this.menu[key]);
                    }
                    break;
                default:
                    this.menuItems = this.menuItems.concat(this.menu[key]);
                    break;
            }
        });
        if (templateSetup !== undefined) {
            this.menuItems = [templateSetup, ...this.menuItems];
        }
        const isAiAgent = await this.AiAgentService.checkAiAgentAsync();
        if (isAiAgent) {
            const analysisMenuIndex = this.menuItems.map(menuItem => menuItem.title).indexOf(this.menu.analysis.title);
            if (analysisMenuIndex !== -1) {
                if (this.template === 'aiAgent') {
                    this.menuItems.splice(analysisMenuIndex, 1);
                }
                else {
                    const aiAgentAnalysisMenuItem = {
                        ...this.menuItems[analysisMenuIndex],
                        sref: aiAgentsAnalyticsStateName,
                        trackClick: 'aiagent-analytics-tab-open',
                    };
                    this.menuItems[analysisMenuIndex] = aiAgentAnalysisMenuItem;
                }
            }
        }
        if (!application.isSubflow) {
            if (this.isPluginsEnabled) {
                await this.ContextProcessorService.waitForInitialization();
                if (this.isBlipStoreEnabled && this.ContextProcessorService.context === Contexts.Tenants) {
                    try {
                        const marketplacePluginTitle = await this.$translate('navbar.marketplacePlugin');
                        const marketplacePlugin = {
                            title: marketplacePluginTitle,
                            sref: blipStoreTemplateStateName,
                            sparams: {
                                path: 'extensions',
                            },
                        };
                        this.menuItems = MenuItemsService.tryAdd(this.menuItems, marketplacePlugin);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                else if (this.isMarketplacePluginEnabled) {
                    /**
                    * Temporary solution
                    * This solution fixes Marketplace plugin on menu items
                    */
                    try {
                        const marketplacePluginTitle = await this.$translate('navbar.marketplacePlugin');
                        const marketplacePlugin = {
                            title: marketplacePluginTitle,
                            sref: 'auth.application.detail.plugin',
                            sparams: {
                                pluginId: MARKETPLACE_PLUGIN_ID,
                            },
                        };
                        this.menuItems = MenuItemsService.tryAdd(this.menuItems, marketplacePlugin);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                try {
                    const plugins = await this.ExternalPluginService.getPlugins(this.isConfigurationsApplicationsDomainUsageGetEnabled);
                    const smartSalesPluginId = SmartSalesConstants.SMART_SALES_PLUGIN_ID;
                    for (const pluginId of Object.keys(plugins)) {
                        if (pluginId === smartSalesPluginId &&
                            this.isSmartSalesEnabled) {
                            continue;
                        }
                        const plugin = {
                            title: plugins[pluginId].name,
                            sref: 'auth.application.detail.plugin',
                            sparams: {
                                pluginId: pluginId,
                            },
                            trackClick: `${pluginId}-opened`,
                        };
                        this.menuItems = MenuItemsService.tryAdd(this.menuItems, plugin);
                    }
                }
                catch (err) {
                    if (err.code !== 67) { // Resource not found
                        console.error(err);
                    }
                }
            }
            try {
                if (await this.SortMenuOptionsService.isCustomMenuOrder(this.isConfigurationsApplicationsDomainUsageGetEnabled)) {
                    this.menuItems = await this.SortMenuOptionsService.sortMenuOptions(this.menuItems);
                }
            }
            catch (err) {
                if (err.code !== 67) { // Resource not found
                    console.error(err);
                }
            }
        }
        return this.menuItems;
    }
    static tryAdd(menuItems, item) {
        const itemAlreadyInMenu = menuItems.some(menuItem => {
            return menuItem.title == item.title;
        });
        return itemAlreadyInMenu ? menuItems : [...menuItems, item];
    }
    async getMenuIcons() {
        this.menuIcons = [];
        const application = this.$rootScope.application;
        const keys = Object.keys(menuIconsJson).filter(key => menuIconsJson[key].claims.some(claimId => application.applicationUserPermissionModel.some(userPermission => userPermission.permissionClaim == claimId &&
            userPermission.permissionAction > 0)));
        keys.forEach(x => this.menuIcons.push(menuIconsJson[x]));
        this.menuIcons = await this.checkMenuIconsAiAgentAsync();
        //Template specific
        return this.menuIcons;
    }
    async checkMenuIconsAiAgentAsync() {
        if (await this.AiAgentService.checkAiAgentAsync()) {
            return this.menuIcons.filter(item => item.displayWhenAiAgent === true);
        }
        return this.menuIcons;
    }
    getTemplateSetupItem() {
        this.template = this.$rootScope.application.template;
        if (!this.$rootScope.application.applicationUserPermissionModel.some(p => p.permissionClaim === 109 && p.permissionAction > 0)) {
            return undefined;
        }
        switch (this.template) {
            case 'operator':
                return {
                    title: 'modules.application.detail.setup',
                    sref: 'auth.application.detail.operator',
                };
            case 'faq':
                return {
                    title: 'modules.application.detail.setup',
                    sref: 'auth.application.detail.faq',
                };
            case 'faq2':
                return {
                    title: 'modules.application.detail.setup',
                    sref: 'auth.application.detail.faq2',
                };
            case 'master':
                return {
                    title: 'master.services',
                    sref: 'auth.application.detail.master',
                };
            case 'webhook':
                return {
                    title: 'modules.application.detail.setup',
                    sref: 'auth.application.detail.webhook',
                };
            case 'aiAgents':
                return {
                    title: 'modules.application.detail.aiAgents.title',
                    sref: 'auth.application.detail.aiAgents',
                };
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
MenuItemsService.$inject = ['$rootScope', 'ExternalPluginService', 'SortMenuOptionsService', '$translate', 'ContextProcessorService', 'AiAgentService', 'StudioService'];
